import { FC, JSX, useEffect, useState } from 'react';

import Modal from '@semcore/modal';
import Textarea from '@semcore/textarea';

import Button from '@/shared/ui/button';

interface IEnterURLsModalProps {
  urls?: string;
  visible?: boolean;
  onClose: () => void;
  onSave: (newUrls: string) => void;
}

const EnterURLsModal: FC<IEnterURLsModalProps> = ({
  urls = '',
  visible = false,
  onClose,
  onSave,
}): JSX.Element => {
  const [currentValue, setCurrentValue] = useState<string>(urls);

  useEffect(() => {
    if (visible) {
      setCurrentValue(urls);
    }
  }, [visible, urls]);

  return (
    <Modal visible={visible} onClose={onClose}>
      <Modal.Title>Adding links</Modal.Title>
      <div className="flex flex-col gap-6">
        <div className="text-base font-light">
          Enter one or more links that you want to allow
          <br />
          or exclude
        </div>
        <div className="flex min-w-[600px]">
          <Textarea
            value={currentValue}
            disabled={false}
            maxRows={10}
            minRows={10}
            placeholder={
              'https://example.com/news/*\nhttps://example.com/page'
            }
            readOnly={false}
            resize="vertical"
            size="l"
            state="normal"
            onChange={setCurrentValue}
          />
        </div>
        <div className="flex items-center justify-end gap-4">
          <Button
            variant="function"
            size="md"
            title="Cancel"
            onClick={onClose}
          />
          <Button
            variant="primary"
            size="md"
            title="Save"
            onClick={() => onSave(currentValue)}
          />
        </div>
      </div>
    </Modal>
  );
};

export default EnterURLsModal;
